module.exports = __webpack_public_path__ + "img/under-development.e5d8333a.svg";